import React, { useRef } from 'react';
import { Modal, Button, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import qs from 'qs';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';

const Bot = ({ error, open, type, isLoading, isLoadingSubmit, onSubmit, onHide }) => {
  const formNode = useRef(null);

  const onSubmitForm = (event) => {
    event?.preventDefault();
    const current = formNode?.current;
    const data = new FormData(current);
    const payload = {};
    for (const name of data.keys()) {
      if (formNode.current?.[name]) {
        payload[name] = formNode.current[name].value;
      }
    }
    const parsePayload = qs.parse(payload);
    onSubmit?.(type, parsePayload);
  };

  return (
    <Modal show={open} onHide={!isLoadingSubmit ? onHide : undefined} backdrop="static">
      <form ref={formNode} onSubmit={onSubmitForm}>
        <Modal.Header closeButton>
          <Modal.Title>{type === 'bot-telegram' ? 'Telegram bot' : null}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading || isLoadingSubmit ? <div className="modal-loader-small" /> : null}
          {error && <Alert text={error} />}
          <Alert type="info" text="Connect a bot so your users can receive notifications there." />
          <div>
            <FormGroup>
              <ControlLabel htmlFor="bot_token">Authentication token</ControlLabel>
              <FormControl type="text" name="bot_token" id="bot_token" />
              <div className="help-block">
                Open
                {' '}
                <a href="https://telegram.me/BotFather" target="_blank" rel="noopener noreferrer">
                  @BotFather
                </a>
                 on Telegram and send ‘/newbot’ command to create your bot and receive its authentication token.
              </div>
            </FormGroup>
          </div>
        </Modal.Body>
        <Modal.Footer className="custom__modal-footer">
          <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit || isLoading} onClick={onSubmitForm}>
            {isLoadingSubmit && <Spinner />}
            <span>Save changes</span>
          </Button>
          <Button
            disabled={isLoadingSubmit || isLoading}
            onClick={() => {
              onHide();
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

Bot.propTypes = {
  error: PropTypes.string,
  open: PropTypes.bool,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default Bot;
